// extracted by mini-css-extract-plugin
module.exports = {"selected":"Artist_selected__VH19M","description":"Artist_description__ca7h0"};